import React, { Component } from "react";
import {Link} from "react-router-dom";



class Service3 extends Component {
  render() {
    return (
        <div>
            {/* ===============  breadcrumb area start =============== */}
            <div className="breadcrumb-area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="breadcrumb-wrap">
                                <h2>Equipment/Machineries Refurbishment and Relocation</h2>
                                <ul className="breadcrumb-links">
                                    <li>
                                        <Link to={`${process.env.PUBLIC_URL}/`}>Home</Link>
                                        <i className="bx bx-chevron-right" />
                                    </li>
                                    <li>Equipment/Machineries Refurbishment and Relocation</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* ===============  breadcrumb area end =============== */}
            {/* ===============  faq wrapper start =============== */}
            <div className="faq-wrapper pt-40">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7">
                            <div className="faq-wrap">
                            <div className="p-timeline-overview">
                              <br/>  <h5>Equipment/Machineries Refurbishment and Relocation</h5><br/>
                                <p>Our goal is to help the customer by producing equipment that is as close to the original as possible.</p><br/>
                                <p>To refurbish something is to restore it to its original condition. In terms of equipment, refurbishment consists of reassembling and replacing components to restore the equipment to its state when originally manufactured, which is why the process is often referred to as remanufacturing.</p><br/>

                                <p  style={{fontWeight:'bold'}}>When to refurbish</p><br/>
                              <p> Refurbishment, if done at the right time, on the right equipment, and by the right people, can provide significant cost savings when compared to buying new. In order to achieve those cost savings, however, an equipment manager must know when refurbishment is right. The three important factors to consider are the type of machine, the size of the fleet, and the age and condition of the machine.</p><br/>

<p style={{fontWeight:'bold'}}>Potential benefits of refurbishment </p><br/>
<p>Equipment managers are initially drawn to the option of refurbishment because of its cost benefits. Refurbishment typically costs about half as much as buying new and can bring a machine back to like-new condition. In addition to the initial cost savings, refurbishment increases resale value and itcan be recapitalized on a depreciation schedule at half the value of a new machine.</p><br/>

<p style={{fontWeight:'bold'}}>Relocation</p><br/>
<p>The task of relocating an entire plant/machinery is, understandably, an incredibly serious undertaking. For this reason, it’s in your best interest to choose a team you can trust with your entire plant. Below, we’ll outline our plant relocation process so you’ll know exactly what to expect when you choose our services.</p><br/>

<p>Reviewing the Condition of the Equipment</p><br/>
<p>First and foremost, we must review the condition of your equipment prior to relocating any of it. This way, you’ll know whether it received any damage during transportation.</p><br/>
<p>A Well-Thought-Out Layout is the Key to Success</p><br/> 
<p>We’ll have to design the layout that includes every piece of equipment in your previous plant. This way, once we relocate to the new plant, the equipment will be where it needs to be. In fact, we can also optimize the layout of the new plant to boost productivity. This is your chance to make your new plant as efficient and effective as possible and we’ll provide the assistance and guidance necessary to make sure this goes off without a hitch.</p><br/> 
<p>Finally, our qualified team will get to work on transporting your equipment. From our comprehensive solutions, you can expect inspection, shut down, and start-up of the equipment in the new location.</p>


                            </div><br/><br/>



                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {/* ===============  faq wrapper end =============== */}
        </div>
    );
  }
}

export default Service3;
